/* ==========================================================================
   GALLERY — cot thumbnail + hero (anh/video) + mui ten + caption variant
   Tach tu Giorgio-Tea.html, <script> goc dong 2791-2912.

   Doi voi ban goc:
     - boc trong 1 IIFE, khong con bien roi ra global scope
     - them null-guard: trang khong co gallery thi return, khong nem loi
     - export 4 ham ra window vi cho khac trong trang goi den chung:
         showVariantHero / clearVariantHero  <- dropdown chon vi (dong 3514-3516)
         resetHeroToGallery                  <- sau khi them vao gio (dong 4295, 4353)
         selectThumbByIndex                  <- tien cho ban goi tay
   ========================================================================== */
(function () {
  const heroImg = document.getElementById('heroImg');
  const heroFrameEl = document.querySelector('.hero-frame');
  if (!heroImg || !heroFrameEl) return;

  // Hero thumbnail row
  const thumbImgs = Array.from(document.querySelectorAll('.thumb-col img'));

  // Lock the thumbnail column's height to exactly match the hero image, so extra
  // thumbnails scroll internally instead of spilling past the hero's bottom edge.
  const thumbCol = document.getElementById('thumbCol');
  const thumbColWrap = document.querySelector('.thumb-col-wrap');
  const thumbScrollFade = document.getElementById('thumbScrollFade');
  const thumbScrollDown = document.getElementById('thumbScrollDown');

  // Duoi 860px, CSS chuyen cot thumbnail thanh hang ngang (.gallery column-reverse).
  // Phai khop VOI @media (max-width:860px) trong CSS — doi mot ben la lech ngay.
  const stacked = window.matchMedia('(max-width: 860px)');

  function updateThumbScrollFade() {
    if (!thumbCol || !thumbScrollFade) return;
    // Hang ngang thi mui ten "cuon xuong" vo nghia, CSS da an no.
    if (stacked.matches) {
      thumbScrollFade.style.opacity = '0';
      thumbScrollFade.style.pointerEvents = 'none';
      return;
    }
    const atBottom = thumbCol.scrollTop + thumbCol.clientHeight >= thumbCol.scrollHeight - 2;
    const scrollable = thumbCol.scrollHeight > thumbCol.clientHeight + 2;
    const show = scrollable && !atBottom;
    thumbScrollFade.style.opacity = show ? '1' : '0';
    thumbScrollFade.style.pointerEvents = show ? 'auto' : 'none';
  }

  function syncThumbColHeight() {
    if (thumbColWrap) {
      if (stacked.matches) {
        // FIX: bo chieu cao inline. Neu khong, gia tri cua desktop (= chieu cao hero)
        // dinh lai va tao mot khoang trong bang ca cai anh duoi hang thumbnail.
        thumbColWrap.style.height = '';
      } else {
        const h = heroFrameEl.offsetHeight;
        if (h > 0) thumbColWrap.style.height = h + 'px';
      }
    }
    updateThumbScrollFade();
  }

  // Xoay ngang dien thoai / keo cua so qua lai breakpoint van phai dung
  if (stacked.addEventListener) stacked.addEventListener('change', syncThumbColHeight);
  else if (stacked.addListener) stacked.addListener(syncThumbColHeight);

  if (thumbScrollDown && thumbCol) {
    thumbScrollDown.addEventListener('click', () => {
      thumbCol.scrollBy({ top: 164, behavior: 'smooth' });
    });
  }
  if (thumbCol) thumbCol.addEventListener('scroll', updateThumbScrollFade);
  window.addEventListener('resize', syncThumbColHeight);
  window.addEventListener('load', syncThumbColHeight);
  syncThumbColHeight();

  const prevBtn = document.getElementById('heroArrowPrev');
  const nextBtn = document.getElementById('heroArrowNext');

  function updateArrowState() {
    if (!prevBtn || !nextBtn) return;
    const current = thumbImgs.findIndex(i => i.classList.contains('active'));
    prevBtn.disabled = current <= 0;
    nextBtn.disabled = current !== -1 && current >= thumbImgs.length - 1;
    prevBtn.style.opacity = prevBtn.disabled ? '0.35' : '1';
    nextBtn.style.opacity = nextBtn.disabled ? '0.35' : '1';
    prevBtn.style.cursor = prevBtn.disabled ? 'default' : 'pointer';
    nextBtn.style.cursor = nextBtn.disabled ? 'default' : 'pointer';
  }

  const heroVideo = document.getElementById('heroVideo');

  // Thumbnail chi la ban 90x90. Anh hero lay tu data-src (900x) tren chinh cai thumb do,
  // neu theme khong xuat data-src thi moi lui ve src.
  function heroSrcOf(img) {
    return img.dataset.src || img.getAttribute('data-src') || img.src;
  }

  // True while the hero is showing a flavor variant rather than a gallery photo.
  let variantHeroActive = false;
  const heroCaption = document.getElementById('heroVariantCaption');

  function showVariantHero(src, label) {
    if (!src) return;
    variantHeroActive = true;
    if (heroVideo) { heroVideo.pause(); heroVideo.style.display = 'none'; }
    thumbImgs.forEach(i => i.classList.remove('active'));
    heroImg.style.opacity = 0;
    setTimeout(() => { heroImg.src = src; heroImg.style.opacity = 1; }, 150);
    if (heroCaption) {
      heroCaption.textContent = label || '';
      heroCaption.style.opacity = label ? '1' : '0';
    }
    updateArrowState();
  }

  function clearVariantHero() {
    variantHeroActive = false;
    if (heroCaption) heroCaption.style.opacity = '0';
  }

  // After an item is added the configurator resets, so the frame goes back to the
  // gallery's first photo rather than keeping the last flavor's variant shot.
  function resetHeroToGallery() {
    if (variantHeroActive) selectThumbByIndex(0);
  }

  function selectThumbByIndex(idx) {
    const img = thumbImgs[idx];
    if (!img) return;
    clearVariantHero();
    thumbImgs.forEach(i => i.classList.remove('active'));
    img.classList.add('active');

    const videoWrap = img.closest('.thumb-video-wrap');
    if (videoWrap && heroVideo) {
      // Video thumbnail: swap the hero over to the <video> element instead of the image.
      heroVideo.src = videoWrap.dataset.videoSrc;
      heroImg.style.opacity = 0;
      heroVideo.style.display = 'block';
      heroVideo.play().catch(() => {});
    } else {
      // heroVideo only exists on the biscotti page. Guarding the `if` condition was not
      // enough — this branch dereferenced it too, so on every page WITHOUT a video
      // thumbnail the click handler threw here and the hero never swapped.
      if (heroVideo) {
        heroVideo.pause();
        heroVideo.style.display = 'none';
      }
      heroImg.style.opacity = 0;
      setTimeout(() => { heroImg.src = heroSrcOf(img); heroImg.style.opacity = 1; }, 150);
    }
    updateArrowState();
  }

  thumbImgs.forEach((img, idx) => {
    img.addEventListener('click', () => selectThumbByIndex(idx));
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const current = thumbImgs.findIndex(i => i.classList.contains('active'));
      if (current > 0) selectThumbByIndex(current - 1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const current = thumbImgs.findIndex(i => i.classList.contains('active'));
      // From a variant photo, forward returns to the first gallery shot.
      if (current === -1) return selectThumbByIndex(0);
      if (current < thumbImgs.length - 1) selectThumbByIndex(current + 1);
    });
  }
  updateArrowState();

  // Cho phan con lai cua trang goi vao (dropdown chon vi, reset sau khi add to cart)
  window.showVariantHero   = showVariantHero;
  window.clearVariantHero  = clearVariantHero;
  window.resetHeroToGallery = resetHeroToGallery;
  window.selectThumbByIndex = selectThumbByIndex;
})();


(function () {
  const WRAP_SEL = '.fd-wrap';
  const OPT_SEL = '.fd-option, .fd-collection-row';

  // Trang thai phai song NGOAI DOM: element bi thay moi lan doi variant, nen
  // luu tren element la mat ngay sau lan chon dau tien.
  const pickedKeys = new Set();     // key -> khach da chon that su chua
  const lastValue = new Map();      // key -> value da chon lan gan nhat
  const keyOf = w => w.id || 'fd-default';

  /* ---------- helper: tat ca deu tra cuu LIVE, khong cache ---------- */
  const menuOf = w => w.querySelector('.fd-menu');
  const nameOf = w => w.querySelector('.fd-trigger-name');
  const subOf = w => w.querySelector('.fd-trigger-sub');
  const optionsOf = w => Array.from(w.querySelectorAll(OPT_SEL));

  function valueOf(el) {
    if (!el) return '';
    const dv = el.getAttribute('data-value');
    if (dv) return dv;
    const t = el.querySelector('.fd-option-name-text, .fd-collection-title');
    return t ? t.textContent.trim() : '';
  }
  function descOf(el) {
    const s = el && el.querySelector('.fd-option-sub');
    return s ? s.textContent.trim() : '';
  }
  function promptOf(w) {
    return w.getAttribute('data-prompt') || 'Choose your tea';
  }

  /* ---------- dong bo sang control that cua theme ---------- */
  function syncNative(wrap, value) {
    let el = null;

    const sel = wrap.getAttribute('data-sync');
    if (sel) el = document.querySelector(sel);

    // Khong khai bao data-sync: do tim trong cung form mot <select> co option
    // trung value, hoac mot radio co value trung.
    if (!el) {
      const scope = wrap.closest('form') || document;
      el = Array.from(scope.querySelectorAll('select')).find(s =>
        Array.from(s.options).some(o => o.value === value || o.textContent.trim() === value)
      );
      if (!el) {
        const radio = Array.from(scope.querySelectorAll('input[type="radio"]'))
          .find(r => r.value === value);
        if (radio) el = radio;
      }
    }
    if (!el) return false;

    if (el.type === 'radio') {
      if (el.checked) return true;
      el.checked = true;
    } else {
      if (el.value === value) return true;
      el.value = value;
    }
    // Theme lang nghe 'change'; vai theme lang nghe 'input'. Ban ca hai.
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* ---------- chon ---------- */
  // picked = false: dong bo giao dien theo DOM, khong coi la thao tac cua khach
  //          va khong ban su kien sang theme.
  function apply(wrap, el, picked) {
    const nEl = nameOf(wrap);
    const sEl = subOf(wrap);

    optionsOf(wrap).forEach(o => o.classList.toggle('selected', o === el));

    if (nEl) {
      // Hien thi uu tien data-label (ten than thien, vd "Matte Black Lid"),
      // con data-value giu nguyen ten option value cua Shopify de syncNative
      // con tim dung radio. Khong co data-label thi chay y nhu cu.
      nEl.textContent = el ? (el.getAttribute('data-label') || valueOf(el)) : promptOf(wrap);
      nEl.style.color = el ? '' : 'var(--support-gray)';
    }
    if (sEl) sEl.innerHTML = '';
    wrap.classList.toggle('chosen', !!el);
    if (el && picked) {
      pickedKeys.add(keyOf(wrap));
      lastValue.set(keyOf(wrap), valueOf(el));
    }

    if (el) {
      wrap.classList.remove('needs-choice');
      const err = document.getElementById('flavorErrorMsg');
      if (err) err.style.display = 'none';
    }

    if (el && picked) {
      // Anh rieng cua vi duoc chon chiem khung hero. Co y KHONG day vao cot
      // thumbnail — gallery van la bo anh co dinh cua san pham.
      const hero = el.getAttribute('data-hero');
      if (hero && typeof window.showVariantHero === 'function') {
        window.showVariantHero(hero, valueOf(el));
      } else if (typeof window.clearVariantHero === 'function') {
        window.clearVariantHero();
      }
      syncNative(wrap, valueOf(el));
    }

    if (typeof window.recalc === 'function') window.recalc();
    if (typeof window.updateCtaTotal === 'function') window.updateCtaTotal();
  }

  /* ---------- chuan hoa mot .fd-wrap vua xuat hien trong DOM ---------- */
  function normalize(wrap) {
    if (!wrap || wrap.dataset.fdReady === '1') return;
    wrap.dataset.fdReady = '1';

    // Chu goc tren trigger la loi moi mac dinh — nho lai truoc khi ghi de.
    if (!wrap.hasAttribute('data-prompt')) {
      const n = nameOf(wrap);
      if (n) wrap.setAttribute('data-prompt', n.textContent.trim());
    }
    // Be rong sot lai tu lan render truoc; do lai luc mo.
    const m = menuOf(wrap);
    if (m) m.style.width = '';

    apply(wrap, resolveSelected(wrap), false);
  }

  /* ---------- xac dinh option nao dang duoc chon, theo 3 nguon ----------
     Sau khi doi variant, markup moi thuong KHONG dang tin: Liquid hoac quen
     danh dau selected, hoac danh dau ca 11 dong (thieu dieu kien
     `{% if option.selected_value == value %}`). Nen thu lan luot:
       1. Gia tri module da nho tu lan chon truoc  <- song qua moi lan re-render
       2. Dung MOT .selected trong markup
       3. Gia tri hien tai cua control that (data-sync)
     Het ca ba thi coi nhu chua chon, hien lai loi moi.                     */
  function resolveSelected(wrap) {
    const opts = optionsOf(wrap);

    const remembered = lastValue.get(keyOf(wrap));
    if (remembered) {
      const hit = opts.find(o => valueOf(o) === remembered);
      if (hit) return hit;
    }

    const marked = opts.filter(o => o.classList.contains('selected'));
    if (marked.length === 1) return marked[0];

    // Shopify LUON co san mot variant duoc chon, nen neu tin control that ngay
    // tu dau thi trigger khong bao gio hien duoc loi moi "Choose Your Tea".
    // Mac dinh chi doc no SAU khi khach da chon that su. Muon dropdown luon
    // bam theo variant hien tai (ke ca lan load dau), dat data-follow-native="1".
    if (pickedKeys.has(keyOf(wrap)) || wrap.getAttribute('data-follow-native') === '1') {
      const nv = nativeValue(wrap);
      if (nv) {
        const hit = opts.find(o => valueOf(o) === nv);
        if (hit) return hit;
      }
    }
    return null;
  }

  function nativeValue(wrap) {
    const sel = wrap.getAttribute('data-sync');
    const el = sel ? document.querySelector(sel) : null;
    if (!el) return '';
    if (el.type === 'radio') return el.checked ? el.value : '';
    return el.value || '';
  }

  function normalizeAll(root) {
    (root || document).querySelectorAll(WRAP_SEL).forEach(normalize);
  }

  /* ---------- mo / dong ---------- */
  // Menu bung sang phai vao khoang trong ben phai trang thay vi de len gallery.
  // Do be rong ngay luc mo nen luon dung truoc mep viewport.
  function sizeMenu(wrap) {
    const menu = menuOf(wrap);
    if (!menu) return;
    // The menu used to be widened into whatever space was free to the right,
    // up to 660px, so long collection names would not truncate. It overhung the
    // field it belongs to and covered Add to Bag — and truncated anyway. The
    // stylesheet now pins it to the field and the ROW wraps instead, so the only
    // job left here is clearing any width a previous version left behind.
    menu.style.width = '';
  }

  function closeAll(except) {
    document.querySelectorAll('.cd-wrap.open, .fd-wrap.open').forEach(w => {
      if (w !== except) w.classList.remove('open');
    });
  }

  /* ---------- LISTENER: gan mot lan tren document, khong bao gio chet ---------- */
  document.addEventListener('click', (e) => {
    // 1. Nut "View N flavors" cua bo suu tap: chi de xem, khong bao gio chon.
    const toggle = e.target.closest('.fd-collection-toggle');
    if (toggle) {
      e.stopPropagation();
      const row = toggle.closest('.fd-collection-row');
      const list = row && row.querySelector('.fd-collection-list');
      const chev = toggle.querySelector('.fd-collection-chevron');
      if (list) list.hidden = !list.hidden;
      if (chev) chev.classList.toggle('open', list ? !list.hidden : false);
      return;
    }

    // 2. Bam vao trigger -> mo / dong
    const trigger = e.target.closest('.fd-trigger');
    if (trigger) {
      const wrap = trigger.closest(WRAP_SEL);
      if (wrap) {
        normalize(wrap);
        const willOpen = !wrap.classList.contains('open');
        closeAll();
        if (willOpen) { wrap.classList.add('open'); sizeMenu(wrap); }
      }
      return;
    }

    // 3. Bam vao mot dong trong menu -> chon
    const opt = e.target.closest(OPT_SEL);
    if (opt) {
      const wrap = opt.closest(WRAP_SEL);
      if (wrap) {
        normalize(wrap);          // phong khi observer chua kip chay
        apply(wrap, opt, true);
        wrap.classList.remove('open');
      }
      return;
    }

    // 4. Bam ra ngoai -> dong het
    closeAll();
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.fd-wrap.open').forEach(sizeMenu);
  });

  /* ---------- BAT DOM BI THAY (doi variant / section render lai) ---------- */
  // Chi lam viec khi xuat hien .fd-wrap chua co co data-fd-ready, nen gan nhu
  // khong ton gi du observer gan tren body.
  // KHONG dung requestAnimationFrame o day. rAF dat lich tu trong callback cua
  // MutationObserver co the KHONG BAO GIO chay (tab bi throttle, hoac trinh
  // duyet khong dat lich ve frame moi vi mutation dien ra giua chuoi xu ly
  // click dong bo). Khi do latch ket lai va observer chet sau dung mot lan —
  // trieu chung y het: doi variant lan dau con dung, tu lan hai la text reset.
  let queued = false;
  const scheduleNormalize = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;                       // nha latch TRUOC, du ben duoi co loi
      try {
        if (document.querySelector('.fd-wrap:not([data-fd-ready="1"])')) normalizeAll();
      } catch (err) {
        if (window.console) console.error('[flavor-dropdown]', err);
      }
    }, 0);
  };
  new MutationObserver(scheduleNormalize)
    .observe(document.documentElement, { childList: true, subtree: true });

  // Shopify ban su kien nay khi section duoc render lai trong theme editor.
  document.addEventListener('shopify:section:load', (e) => normalizeAll(e.target));

  /* ---------- khoi tao ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeAll());
  } else {
    normalizeAll();
  }

  /* ---------- API ---------- */
  const mainWrap = () => document.querySelector('#flavorDropdown') || document.querySelector(WRAP_SEL);

  window.selectFlavor = function (value, picked) {
    const wrap = mainWrap();
    if (!wrap) return;
    const el = optionsOf(wrap).find(o => valueOf(o) === value);
    if (el) apply(wrap, el, picked !== false);
  };
  window.getSelectedFlavor = function () {
    const wrap = mainWrap();
    const el = wrap && wrap.querySelector('.fd-option.selected, .fd-collection-row.selected');
    return el ? { value: valueOf(el), sub: descOf(el), el: el } : null;
  };
  window.isFlavorPicked = function () {
    const wrap = mainWrap();
    return !!(wrap && pickedKeys.has(keyOf(wrap)));
  };
})();


(function () {
  const SELECTOR = '.sealsubs-target-element';           // widget Seal
  const TARGET = '.sls-selling-plan-group-options';      // o chon tan suat cua Seal
  const TIMEOUT_MS = 30000;                              // bo cuoc sau 30s, khong quan sat mai
  const t0 = performance.now();

  // 1. Khoi mo ta, chen NGAY TRUOC o chon tan suat
  const BODY_FALLBACK = 'Your afternoon ritual, replenished on your schedule.<br>Skip, reschedule, or cancel anytime.';

  // 2. Nhan tren hang nut tan suat
  const FREQ_FALLBACK = 'How Often Should We Send Your Tea?';

  /* ---- copy the merchant can edit ------------------------------------------
     These two lines used to be hard-coded here, which is why the biscotti page
     sat for weeks showing the candle page's wording (this file began as a copy
     of it) and the client could not correct it from the theme editor -- there
     was nothing to edit. main-product-giorgio.liquid now publishes whatever is
     typed into the section's "Subscription wording" fields as window.ggSubCopy;
     the lines above stay as the fallback, so a shop that leaves those fields
     empty renders exactly as before. */
  const GG_SUB = window.ggSubCopy || {};
  const BODY_HTML = '<div id="pkgSubBody">' + (GG_SUB.body || BODY_FALLBACK) + '</div>';
  const FREQ_LABEL = GG_SUB.freq || FREQ_FALLBACK;

  // 3. Link duoi hang nut. Doi HELP_HREF thanh URL that neu co trang huong dan.
  const HELP_TEXT = 'How Many Tins Do I Need?';
  const HELP_HREF = '#';
  const HELP_CLASS = 'bags-help-link';   // dung class, khong dung id: co the dat
                                         // nhieu link mo popup o nhieu cho khac nhau

  // Doi ten nut. Key = text goc cua <option> ben Seal (khong phan biet hoa thuong).
  // Khong khop key nao thi giu nguyen text cua Seal.
  const RENAME = {
    'every 1 month': 'Monthly',
    'every 2 months': 'Every 2 Months',
    'every 3 months': 'Every 3 Months',
    'every 12 months': 'Annual Gift'
  };

  const CSS = [
    "#pkgSubBody{font-family:'Montserrat',sans-serif;font-size:13.5px;line-height:1.6;color:var(--ink-soft,#5A524F);margin:12px 0 0;}",
    '#pkgSubFreq{margin:16px 0 0;border-top:1px solid var(--gray,#D9D9D6);padding-top:16px;}',
    "#pkgFreqLabel{font-family:'Montserrat',sans-serif;font-size:11.5px;letter-spacing:.09em;text-transform:uppercase;color:var(--ink,#2B2523);margin-bottom:10px;}",
    '#pkgFreqOptions{display:flex;gap:6px;flex-wrap:wrap;}',
    '.' + HELP_CLASS + "{display:inline-block;margin-top:12px;font-family:'Montserrat',sans-serif;font-size:11.5px;letter-spacing:.09em;text-transform:uppercase;color:var(--support-gray,#808080);text-decoration:underline;}",
    ".pkg-freq-btn{font-family:'Montserrat',sans-serif;font-size:13.5px;color:var(--ink,#2B2523);background:var(--white,#fff);border:1.5px solid var(--gray,#D9D9D6);border-radius:0;padding:11px 10px;cursor:pointer;white-space:nowrap;transition:border-color .15s,color .15s;}",
    '.pkg-freq-btn:hover{border-color:#B3B3B3;}',
    '.pkg-freq-btn.selected{border-color:var(--raspberry,#CE0F69);color:var(--raspberry,#CE0F69);}'
  ].join('\n');

  let observer = null;
  let timer = null;

  function stop() {
    if (observer) { observer.disconnect(); observer = null; }
    if (timer) { clearTimeout(timer); timer = null; }
  }

  // Widget co the xuat hien TRUOC khi ruot no render xong, nen dieu kien "san
  // sang" phai la cho can chen, khong phai chi rieng .sealsubs-target-element.
  function findSpot() {
    const root = document.querySelector(SELECTOR);
    return root ? root.querySelector(TARGET) : null;
  }

  function injectCss() {
    if (document.getElementById('gg-freq-css')) return;
    const s = document.createElement('style');
    s.id = 'gg-freq-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // Bien <select> cua Seal thanh hang nut pill. Giu nguyen cai <select>, chi an
  // di — bam nut la ghi value roi ban 'change' de logic cua Seal chay binh thuong.
  function buildPills(spot) {
    const select = spot.querySelector('select');
    if (!select) {
      console.warn('[seal] khong thay <select> trong ' + TARGET + ' — chua doi thanh nut duoc.');
      console.warn('  innerHTML:', spot.innerHTML);
      return;
    }
    if (spot.querySelector('#pkgSubFreq')) return;

    select.style.display = 'none';

    const box = document.createElement('div');
    box.id = 'pkgSubFreq';

    const label = document.createElement('div');
    label.id = 'pkgFreqLabel';
    label.textContent = FREQ_LABEL;

    const row = document.createElement('div');
    row.id = 'pkgFreqOptions';

    Array.from(select.options).forEach(function (opt) {
      const raw = opt.textContent.trim();
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pkg-freq-btn' + (opt.selected ? ' selected' : '');
      btn.setAttribute('data-value', opt.value);
      btn.textContent = RENAME[raw.toLowerCase()] || raw;

      btn.addEventListener('click', function () {
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        row.querySelectorAll('.pkg-freq-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
      });

      row.appendChild(btn);
    });

    box.appendChild(label);
    box.appendChild(row);

    if (!spot.querySelector('.' + HELP_CLASS)) {
      const help = document.createElement('a');
      help.className = HELP_CLASS;
      help.href = HELP_HREF;
      help.textContent = HELP_TEXT;
      box.appendChild(help);
    }

    spot.appendChild(box);
  }

  function found(spot, how) {
    stop();
    const ms = Math.round(performance.now() - t0);

    injectCss();
    if (!document.getElementById('pkgSubBody')) {
      spot.insertAdjacentHTML('beforebegin', BODY_HTML);
    }
    buildPills(spot);

    window.$seal = document.querySelector(SELECTOR);
    console.log('[seal] xong sau ' + ms + 'ms (' + how + ')');
    console.log('  -> da gan vao window.$seal');
  }

  /* --------------------------------------------------------------------
     Bam "How Many Tins Do I Need?" -> mo modal.
     CSS co san: .pair-modal{display:none} / .pair-modal.open{display:flex}
     Uu tien #planModal, khong co thi lay .pair-modal dau tien.
     Khong tim thay modal nao thi KHONG chan link — de no chay binh thuong.
     Dat listener tren document nen khong phu thuoc thu tu render.
     -------------------------------------------------------------------- */
  const MODAL_ID = 'planModal';

  function getModal() {
    return document.getElementById(MODAL_ID) || document.querySelector('.pair-modal');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.' + HELP_CLASS)) {
      const modal = getModal();
      if (!modal) return;
      e.preventDefault();
      modal.classList.add('open');
      return;
    }
    // Dong: bam nut close, hoac bam ra nen ngoai panel
    const openModal = document.querySelector('.pair-modal.open');
    if (!openModal) return;
    if (e.target.closest('.pair-modal-close') || !e.target.closest('.pair-modal-panel')) {
      openModal.classList.remove('open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const m = document.querySelector('.pair-modal.open');
    if (m) m.classList.remove('open');
  });

  // Co san roi thi khoi quan sat
  const now = findSpot();
  if (now) { found(now, 'da co san luc script chay'); return; }

  observer = new MutationObserver(function () {
    const spot = findSpot();
    if (spot) found(spot, 'MutationObserver');
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  timer = setTimeout(function () {
    stop();
    console.warn('[seal] KHONG thay ' + TARGET + ' sau ' + TIMEOUT_MS + 'ms — da dung quan sat.');
  }, TIMEOUT_MS);
})();
